export default __webpack_public_path__ + "static/media/energy-partner.a9ba9474.png";